import { getRequestCommonParameters } from '@lib/core/service/requests/api';

export const bannersApiUrlCreator = () => {
  const { retailerSlug, retailerLocationSlug } = getRequestCommonParameters();
  return `/${retailerSlug}/${retailerLocationSlug}/banners/`;
};
